<template>
    <div class="share-coin mr-1"
         @click="subscribeModalStore.setSubscribeModal(true, true)">
        <i class="fa-solid fa-star mr-1" />
        <Translate translationKey="cryptocurrencies.learnlist"
                   fallback="Learnlist" />
    </div>
</template>

<script setup lang="ts">
    import { useSubscribeModalStore } from '@/js/store/subscribe/SubscribeModalStore';

    const subscribeModalStore = useSubscribeModalStore();
</script>

<style scoped lang="scss">
@use "@/sass/mixins/_share-coin" as shareCoinMixins;

.share-coin {
    @include shareCoinMixins.share-coin;
}
</style>
